import { useEffect, useState } from "react";

const SIZES = [100, 112.5, 125];

export const TextSizeControl = () => {
  const [idx, setIdx] = useState(() => Math.min(SIZES.length - 1, Math.max(0, Number(localStorage.getItem("sf_text_size")) || 0)));

  useEffect(() => {
    document.documentElement.style.fontSize = `${SIZES[idx]}%`;
    localStorage.setItem("sf_text_size", String(idx));
  }, [idx]);

  return (
    <div className="flex items-center border border-neutral-700" role="group" aria-label="Text size controls">
      <button type="button" onClick={() => setIdx((i) => Math.max(0, i - 1))} disabled={idx === 0}
        data-testid="text-size-decrease" aria-label="Decrease text size"
        className="px-2.5 py-2 text-xs text-neutral-300 hover:text-neon disabled:opacity-40 transition-colors">
        A−
      </button>
      <button type="button" onClick={() => setIdx((i) => Math.min(SIZES.length - 1, i + 1))} disabled={idx === SIZES.length - 1}
        data-testid="text-size-increase" aria-label="Increase text size"
        className="px-2.5 py-2 text-sm text-neutral-300 hover:text-neon disabled:opacity-40 transition-colors border-l border-neutral-700">
        A+
      </button>
    </div>
  );
};
